import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaCheck, FaChevronRight, FaEnvelope, FaShoppingBag, FaTruck } from "react-icons/fa";
import "../css/paysuccess.css";

const PaySuccess = () => {
  const { state } = useLocation();
  const [fallbackOrder] = useState(() => `DZCP-${String(Date.now()).slice(-8)}`);
  const orderNumber = state?.orderNumber || fallbackOrder;
  const total = typeof state?.total === "number" ? `$${state.total.toFixed(2)}` : "Confirmed";
  const email = state?.email || "your email address";

  return (
    <main className="pay-success">
      <section className="pay-success__hero">
        <div className="pay-success__check"><FaCheck /></div>
        <span>ORDER RECEIVED</span>
        <h1>Thank you. Your order is confirmed.</h1>
        <p>We’re preparing your electronics for dispatch. A confirmation has been sent to <strong>{email}</strong>.</p>
      </section>

      <section className="pay-success__card">
        <div className="pay-success__overview">
          <div><span>ORDER NUMBER</span><strong>{orderNumber}</strong></div>
          <div><span>ORDER STATUS</span><strong>Processing</strong></div>
          <div><span>TOTAL</span><strong>{total}</strong></div>
          <div><span>PAYMENT METHOD</span><strong>Credit card</strong></div>
        </div>

        <div className="pay-success__timeline">
          <div className="is-complete"><i><FaCheck /></i><span><strong>Order confirmed</strong><small>Your payment was accepted.</small></span></div>
          <b />
          <div><i><FaShoppingBag /></i><span><strong>Preparing order</strong><small>Usually ready in 1–2 business days.</small></span></div>
          <b />
          <div><i><FaTruck /></i><span><strong>Shipped</strong><small>Tracking will arrive by email.</small></span></div>
        </div>

        <div className="pay-success__notice">
          <FaEnvelope />
          <div><strong>Check your inbox</strong><p>We’ll email shipping updates and a tracking link as soon as your parcel leaves our warehouse.</p></div>
        </div>

        <div className="pay-success__actions">
          <Link to="/shop">CONTINUE SHOPPING <FaChevronRight /></Link>
          <Link to="/contact">Need help with your order?</Link>
        </div>
      </section>
    </main>
  );
};

export default PaySuccess;
